// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__147jV","content":"styles_content__3CTn9","tableWrap":"styles_tableWrap__1eKMI"};